<template>
	<v-card class="pt-3">
		<v-row>
			<v-col cols="12" sm="4">
				<v-list-item three-line>
					<v-list-item-content>
						<v-list-item-title class="headline mb-3 pb-2 secondary--text" style="border-bottom: 1px dashed rgb(191 191 191);">
							<span class="black--text">نوع وام:</span> {{ localData ? localData.loanModel.title : '' }}
						</v-list-item-title>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">شماره وام:</span> {{ localData ? localData.code : '' }}</v-list-item-subtitle>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">تاریخ شروع:</span> {{ localData ? localData.startDate_Persian.date : '' }}</v-list-item-subtitle>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ وام:</span> {{ localData ? localData.amount.toString().toPriceFormat() : '' }} تومان</v-list-item-subtitle>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">باز پرداخت با بهره:</span> {{ localData ? localData.payableAmount.toString().toPriceFormat() : '' }} تومان</v-list-item-subtitle>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">تعداد اقساط:</span> {{ localData ? localData.month : '' }} {{(localData ? localData.monthGap > 1 ? `قسط ${localData.monthGap} ماهه` : "" : '')}}</v-list-item-subtitle>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ هر قسط:</span> {{ localData ? localData.installment.toString().toPriceFormat() : '' }} تومان</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

			</v-col>
			<v-col cols="12" sm="4">
				<v-list-item three-line>
					<v-list-item-content>
						<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
							بازپرداخت ها
						</v-list-item-title>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">تعداد اقساط پرداختی:</span> {{ localData ? localData.paidCount : '' }}</v-list-item-subtitle>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">اقساط پرداخت شده:</span> {{ localData ? localData.paid.toString().toPriceFormat() : '' }} تومان</v-list-item-subtitle>
						<v-list-item-subtitle><span :class="{'red--text':localData && localData.delays > 0}">دیرکرد</span> / <span :class="{'success--text':(localData && localData.delays < 0 )}">زودکرد</span>: <span class="secondary--text">{{ localData ? localData.delays.toString().toPriceFormat() : '' }} تومان</span></v-list-item-subtitle>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ باقیمانده:</span> {{ localData ? Math.abs(localData.remain).toString().toPriceFormat() : '' }} تومان <span class="success--text" v-if="localData && localData.remain < 0">بستانکار</span><span class="red--text" v-if="localData && localData.remain > 0">بدهکار</span></v-list-item-subtitle>
						<v-list-item-subtitle class="secondary--text"><span class="black--text">تسویه شده:</span> {{ localData && localData.isCheckouted ? 'بلی' : 'خیر' }}</v-list-item-subtitle>
						<v-list-item-subtitle class="secondary--text" v-if="localData && localData.isCheckouted">
							<span class="black--text">تاریخ تسویه:</span> {{ localData ? localData.checkoutDate_Persian.date : '' }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

			</v-col>
			<v-col cols="12" sm="4">
				<v-list-item three-line>
					<v-list-item-content>
						<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
							توضیحات:
						</v-list-item-title>
						<div style="white-space: pre-line;">
							{{ localData && localData.description ? localData.description : 'توضیحاتی ثبت نشده است.'}}
						</div>
					</v-list-item-content>

					<div class="checkouted-mark" v-if="localData && localData.isCheckouted">تسویه شده</div>
				</v-list-item>
			</v-col>
		</v-row>

		<v-card-actions class="flex-wrap">
			<div>
				<v-btn-toggle v-model="tab" tile outlined color="deep-purple accent-3">
					<v-btn value="installments">
						لیست اقساط و پرداخت
					</v-btn>

					<v-btn value="assurances">
						تضامین
					</v-btn>

					<v-btn value="checkout">
						مشاهده مبلغ تسویه آنی
					</v-btn>
				</v-btn-toggle>
			</div>
			<v-spacer />
			<v-btn class="mx-1" fab dark small color="secondary" title="ویرایش وام" @click="edit()">
				<v-icon dark>
					mdi-square-edit-outline
				</v-icon>
			</v-btn>
			<v-btn :disabled="!checkPermission('Delete_Loan')" class="mx-2" fab dark small color="pink" title="حذف وام" @click="remove()">
				<v-icon dark>
					mdi-trash-can-outline
				</v-icon>
			</v-btn>
		</v-card-actions>
		<div>
			<div v-if="tab === 'installments'" class="pa-3">
				<loan-installments :data="{userloan:localData, adminPanel:true, hideBack: true}" @changed="loadData" />
			</div>
			<div v-if="tab === 'assurances'" class="pa-3">
				<Assurance :data="localData" />
			</div>
			<div v-if="tab === 'checkout'">
				<div style="text-align:center">
					<div class="mb-2">مبلغ قابل تسویه</div>
					<h3 :class="[checkoutAmount > 0 ? 'red--text' : 'success--text']">{{checkoutAmount.toString().toPriceFormat()}} <span v-if="!isNaN(checkoutAmount)">{{checkoutAmount > 0 ? 'بدهکار' : 'بستانکار'}}</span></h3>
				</div>
			</div>
		</div>
		<v-dialog v-model="dialogModifyUserLoan" scrollable persistent max-width="600px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyUserLoan = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-user-loan ref="modifyUserLoan" v-if="dialogModifyUserLoan" :data="localData" @callbck="callbck_userLoan" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
		<confirm-dlg ref="confirm" />
	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'MemberProfileLoan',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			Assurance: () => import('@/components/forms/Assurance.vue'),
			'modify-user-loan': () => import('@/views/admin/ModifyUserLoan.vue'),
			'loan-installments': () => import('@/views/admin/LoanInstallments.vue'),
		},
		data() {
			return {
				dialogModifyUserLoan: false,
				localData: null,
				errorMessages: '',
				loading: false,
				tab: '',
				checkoutAmount: 0,
			}
		},
		watch: {
			data: {
				deep: true,
				handler(val) {
					this.localData = Object.assign({}, val)
				}
			},
			tab: {
				handler(val) {
					if (val === 'checkout')
						this.showCheckoutAmount()
				}
			}
		},
		mounted() {
			this.localData = Object.assign({}, this.data)
		},
		methods: {
			edit() {
				this.dialogModifyUserLoan = true
			},
			loadData(id = this.localData.id) {
				api.get('admin/userloan/get/' + id, null)
					.then(response => {
						this.localData = response
					})
					.catch(err => {
						toast.error(err.message)
					})
			},
			showCheckoutAmount() {
				this.checkoutAmount = "در حال دریافت اطلاعات ..."
				api.get('admin/userloan/getCheckoutAmount/' + this.localData.id, null)
					.then(
						response => {
							this.checkoutAmount = response
						})
					.catch(err => {
						this.checkoutAmount = err.message
					})
			},
			callbck_userLoan(result) {
				this.dialogModifyUserLoan = false
				if (result) {
					this.tab = ''
					this.loadData()
				}
			},
			async remove() {
				if (!this.localData) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/userloan/delete/' + this.localData.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.$emit('removed', this.localData.id)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
		},
	}
</script>
<style>
</style>
